module.exports = __webpack_public_path__ + "media/control_acceso/abatible-2067beea.png";